import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomFacade, noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { cloneDeep } from 'lodash';
import { GridCellDropdownComponent } from '../grid-cell-dropdown/grid-cell-dropdown.component';
import { setDelayedFlag } from 'libs/shared/src/lib/service/helper.service';
import { GridCellRendererComponent } from '../grid-cell-renderer/grid-cell-renderer.component';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { CookieService } from 'ngx-cookie-service';
import { CustomStorageDataGridService } from '@piqet-angular/features';
@Component({
  selector: 'piqet-angular-new-custom-storage',
  templateUrl: './new-custom-storage.component.html',
  styleUrls: ['./new-custom-storage.component.scss'],
})
export class NewCustomStorageComponent implements OnDestroy {
  customStorageForm!: FormGroup;
  storageProcessForm: any;
  submitted = false;
  processSubmitted = false;
  isReadonly = true;
  processColumnDef: any;
  modalLabel: any;
  customData: any;
  params: any;
  @Output() saveCustomStorageEvent = new EventEmitter<{ payload: any; pathName: any }>();
  editDataList: any;

  isRowEditable = false;
  energyItems: any;
  customStorageId = 0;
  ingredientId: any;
  storageTypeId: any;
  ingredientIndex: any;
  errorNotification: any;
  headerBtn = 'Add row';
  headerBtnName = 'customStorage';
  disableSubmit = false;
  activatedRoute: any;
  selectOrganization: any;
  organizationlist: any;
  selectedDropDownValue: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  fromEdit: any;
  gridLoaded = { value: false };
  setOrganizationValue: any;
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    dropdownRendered: GridCellDropdownComponent,
    GridCellRendererComponent: GridCellRendererComponent,
  };
  showEdit: boolean = false;
  showCreate: boolean = false;
  showView: boolean = false;
  checkEntireAccess: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public customFacade: CustomFacade,
    private customService: CustomService,
    private modal: CustomModalService,
    private swalService: SwalService,
    private sharedService: SharedService,
    private cookieService: CookieService,
    private customStorageDataGridService: CustomStorageDataGridService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.processColumnDef = this.modal?.modalService?.config?.initialState?.['processColDef'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown = this.modalLabel == 'Review custom storage' ? true : false;
    this.isHideDropDown = this.activatedRoute == 'adminCustomStorage' ? true : false;
    this.customData = this.modal?.modalService?.config?.initialState?.['newCustomStorageData'];
    this.fromEdit = this.modal?.modalService?.config?.initialState?.['fromEdit'];
    this.customFacade.GetStorageData$.subscribe((res: any) => {
      this.customData =
        (res.hasOwnProperty('length') && res.length) || (res && res.id) || !this.fromEdit
          ? res
          : this.customData;
      this.initializeData();
    });
  }
  ngOnInit(): void {
    this.showEdit = this.customStorageDataGridService.isAccess(this.activatedRoute, 'edit');
    this.showCreate = this.customStorageDataGridService.isAccess(this.activatedRoute, 'create');
    this.showView = this.customStorageDataGridService.isAccess(this.activatedRoute, 'view');
    this.checkEntireAccess =
      (this.showCreate && !this.fromEdit) ||
      (this.fromEdit && this.showEdit) ||
      (this.fromEdit && !this.showView);
  }

  initializeData() {
    this.customFacade.customStorageEnergyItems$.subscribe((response: any) => {
      this.processColumnDef = cloneDeep(this.processColumnDef);
      this.processColumnDef[0].cellEditorParams['conversionProcessList'] = response;
    });

    this.customStorageId = this.customData.id;
    this.customStorageForm = this.formBuilder.group({
      storageName: [this.customData.processName, [Validators.required, noWhitespaceValidator]],
      organizationName: ['', Validators.required],
      storageProcessForm: this.formBuilder.group({
        process: [null, Validators.required],
        amount: [null, Validators.required],
        cost: [0, [Validators.min(0)]],
        packageCost: [0, Validators.min(0)],
      }),
    });
    this.organizationlist = this.customData.organizationList;
    this.organizatioListFunction();
    this.setFormData();
    this.setOrganizationValue = this.selectOrganization;
    this.selectedDropDownValue = this.selectOrganization;

    this.storageProcessForm = this.customStorageForm.controls['storageProcessForm'];
    this.customFacade.copiedStorageProcess$.subscribe((process: any) => {
      if (process) {
        this.ingredientIndex = process?.index;
        this.ingredientId = process?.id;
        this.storageTypeId = process?.energyProcessId;
        this.customStorageForm.get('storageProcessForm')?.patchValue({
          process: process.energyName,
          amount: process.amount,
          cost: process.cost,
          packageCost: process.packageCost,
        });
      }
    });
    this.customFacade.customStorageEnergyItems$.subscribe((response: any) => {
      this.processColumnDef = cloneDeep(this.processColumnDef);
      this.processColumnDef[0].cellEditorParams['storageProcessList'] = response;
    });

    this.customFacade.customStorageError$.subscribe((error: any) => {
      this.checkValidation(error);
    });

    this.sharedService.disableAddRowBtnTrigger$.subscribe((error: any) => {
      this.checkEditingStatus(error);
    });

    setDelayedFlag(this.gridLoaded, true, 200);
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.customData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  alertConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Are you sure you want to change the organization? if you are change the organization than energy process data will be lost.',
        'organization'
      )
      .then(confirmed => {
        if (confirmed) {
          this.setOrganizationValue = data;
          this.selectedDropDownValue = data;
        } else {
          this.setOrganizationValue = this.selectedDropDownValue;
        }
      });
  }

  selectValue(event: any) {
    if (event.name) {
      this.alertConfirmation(event);
    }
  }

  setFormData() {
    this.customStorageForm.patchValue({ organizationName: this.selectOrganization });
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
  }

  manufactureCost() {
    const amount = this.customStorageForm.controls['storageProcessForm'].value.amount;
    const cost = this.customStorageForm.controls['storageProcessForm'].value.cost;
    this.customService
      .GetPackageCostCalculationCustomStorage(amount, cost)
      .subscribe((data: any) => {
        this.customStorageForm.controls['storageProcessForm']
          .get('packageCost')
          ?.patchValue(data.data);
      });
  }

  addStorageProcess() {
    this.processSubmitted = true;
    if (
      this.storageProcessForm.value.process.name == '-- Select process -- ' &&
      this.storageProcessForm.controls['process'].valid
    ) {
      this.storageProcessForm.get('process')?.reset();
      this.processSubmitted = true;
      this.storageProcessForm.controls['process'].markAsTouched();
      return;
    }
    if (this.storageProcessForm.valid) {
      const processData = {
        energyName:
          this.storageProcessForm.value.process.name || this.storageProcessForm.value.process,
        amount: this.storageProcessForm.value.amount,
        cost: this.storageProcessForm.value.cost,
        packageCost: this.storageProcessForm.getRawValue().packageCost,
        id: 0,
        energyProcessId: this.storageProcessForm.value.process.id || this.storageTypeId,
        customStorageId: this.customStorageId,
      };
      this.processSubmitted = false;
      this.customFacade.addStorageProcessActions(processData, 'add');
      this.storageProcessForm.reset();
    }
  }

  editStorageProcess() {
    this.processSubmitted = true;
    if (
      this.storageProcessForm.value.process.name == '-- Select process -- ' &&
      this.storageProcessForm.controls['process'].valid
    ) {
      this.storageProcessForm.get('process')?.reset();
      this.processSubmitted = true;
      this.storageProcessForm.controls['process'].markAsTouched();
      return;
    }
    if (this.storageProcessForm.valid) {
      const processData = {
        energyName:
          this.storageProcessForm.value.process.name || this.storageProcessForm.value.process,
        amount: this.storageProcessForm.value.amount,
        cost: this.storageProcessForm.value.cost,
        packageCost: this.storageProcessForm.getRawValue().packageCost,
        id: this.ingredientId || 0,
        energyProcessId: this.storageProcessForm.value.process.id || this.storageTypeId,
      };
      this.processSubmitted = false;
      this.customFacade.updateStorageProcessActions(processData, 'edit', this.ingredientIndex);
      this.storageProcessForm.reset();
    }
  }

  checkValidation(storageProcessError: any): void {
    this.disableSubmit = !!storageProcessError ? true : false;
  }

  checkEditingStatus(err: any) {
    if (err == 'editingStarted') {
      this.isRowEditable = true;
    } else if (err == 'editingStopped') {
      this.isRowEditable = false;
    }
  }

  inlineDataEditEvent(record: any) {
    if (record[2] === 'customStorage') {
      this.customService
        .GetPackageCostCalculationCustomStorage(record[1].amount, record[1].cost)
        .subscribe((data: any) => {
          this.customFacade.updateStorageProcessActions(record[1], 'edit', record[3]);
        });
    }
  }

  onSave(storageProcessList: any) {
    this.submitted = true;
    this.processSubmitted = false;
    if (
      this.activatedRoute == 'adminCustomStorage' &&
      !this.customStorageForm.controls['organizationName'].value?.name &&
      !this.customStorageForm.controls['organizationName'].value
    ) {
      return;
    }

    if (!storageProcessList.length) {
      this.customFacade.setStorageProccessError('Please add atleast one storage process.');
      this.disableSubmit = false;
      return;
    } else if (
      this.customStorageForm.errors == null &&
      this.customStorageForm.controls['storageName'].valid
    ) {
      const saveCustomFillingData: any = {
        id: this.customStorageId || 0,
        processName: this.customStorageForm.value.storageName.trimStart(),
        OrganizationId:
          this.customStorageForm.controls['organizationName'].value?.id ||
          this.customData.organizationId ||
          this.cookieService.get('organizationId'),
        customStorageProcesses: storageProcessList,
      };
      this.saveCustomStorageEvent.emit({
        payload: saveCustomFillingData,
        pathName: this.activatedRoute,
      });
      this.submitted = false;
    }
  }

  ngOnDestroy() {
    this.customFacade.clearStorageProcess();
    this.customFacade.ClearAddEditCustomStorageModal();
  }
}
